import allPass from "./allPass";
import compose from "./compose";
import isArray from "./isArray";
import isEmpty from "./isEmpty";
import not from "./not";

const isNonEmptyArray = allPass([isArray, compose(not, isEmpty)]);

export default isNonEmptyArray;
